export default __webpack_public_path__ + "static/media/kitchen5-afterC-768w.46783dbc.avif";